import APIMemberships from '@app/services/API/Memberships';

export const state = () => ({
  list: null,
  current: null,
  count: null,
  searchParams: {
    //
  },
});

export const mutations = {
  setList(state, memberships) {
    state.list = memberships;
  },
  setListData(state, data) {
    if (state.list) {
      state.list.data = data;
    }
  },
  setCurrent(state, membership) {
    state.current = membership;
  },
  add(state, membership) {
    if (!state.list) {
      return;
    }

    state.list.data.push(membership);
  },
  updateSingle(state, membership) {
    if (!state.list) {
      return;
    }

    state.list.data = state.list.data.map((item) => (item.uuid === membership.uuid ? membership : item));
  },
  deleteSingle(state, membership) {
    if (!state.list) {
      return;
    }

    state.list.data = state.list.data.filter((item) => item.uuid !== membership.uuid);
    state.count -= 1;
  },
  setSearchParams(state, params) {
    state.searchParams = params;
  },
  setCount(state, count) {
    state.count = count;
  },
};

export const getters = {
  count: (state) => state.count,
  current: (state) => state.current,
  list: (state) => state.list,
};

export const actions = {
  fetch({ state, commit }) {
    return APIMemberships.getMemberships(state.searchParams)
      .then(({ data }) => {
        commit('setList', { data });
      });
  },

  count({ commit }) {
    return APIMemberships.count()
      .then(({ data }) => {
        commit('setCount', data.count);
      });
  },

  find({ commit }, uuid) {
    return APIMemberships.getMembership(uuid)
      .then((data) => {
        commit('setCurrent', data.data);
        return data.data;
      })
      .catch((error) => {
        console.error('Error fetching membership:', error);
        throw error;
      });
  },

  create({ commit }, membershipData) {
    return APIMemberships.createMembership(membershipData)
      .then((data) => {
        commit('add', data.data);
        return data.data;
      });
  },

  update({ commit }, { uuid, membershipData }) {
    return APIMemberships.updateMembership(uuid, membershipData)
      .then((data) => {
        commit('updateSingle', data.data);
        commit('setCurrent', data.data);
        return data.data;
      });
  },

  delete({ commit }, membership) {
    return APIMemberships.deleteMembership(membership.uuid)
      .then(() => {
        commit('deleteSingle', membership);
      });
  },

  reorder({ commit }, memberships) {
    commit('setListData', memberships);

    const reorderedData = memberships.map((membership, index) => ({
      uuid: membership.uuid,
      order: index,
    }));

    return APIMemberships.reorderMemberships(reorderedData)
      .then((data) => data.data);
  },
};
